import type { Service, Quote } from '../types'

export function getPromo(quote: Quote) {
  return quote.promos.length ? quote.promos[quote.promos.length - 1] : null
}

export function getAmount(quote: Quote) {
  const promo = getPromo(quote)
  return promo ? promo.receivedAmount : quote.receivedAmount
}

export function promotionalQuoteFees(service: Service) {
  if (!service.promotion?.fee) {
    return null
  }
  return (
    (service.promotion.fee.transfer ?? service.quote.fee.transfer) +
    (service.promotion.fee.payin ?? service.quote.fee.payin) +
    (service.promotion.fee.payout ?? service.quote.fee.payout)
  )
}

export function standardQuoteFees(service: Service): number {
  return service.quote.fee.transfer + service.quote.fee.payin + service.quote.fee.payout
}

export function externalFees(service: Service): number {
  return service.quote.fee.externalPayin + service.quote.fee.externalPayout
}

export function totalFees(quote: Quote) {
  const promo = getPromo(quote)
  return promo?.fee?.total ?? quote.fee.total
}

export function exchangeRateMargin(rate: number, midMarket: number) {
  return ((midMarket - rate) / midMarket) * 100
}

export function exchangeRateFee(amountSent: number, midMarket: number, quote: Quote) {
  const promo = getPromo(quote)
  const rate = promo?.rate ?? quote.rate
  const fees = totalFees(quote)
  return (amountSent - fees) * (exchangeRateMargin(rate, midMarket) / 100)
}

export function standardExchangeRateFee(amountSent: number, midMarket: number, quote: Quote) {
  return (amountSent - quote.fee.total) * (exchangeRateMargin(quote.rate, midMarket) / 100)
}

export function totalCost(amountSent: number, midMarket: number, quote: Quote) {
  return totalFees(quote) + exchangeRateFee(amountSent, midMarket, quote)
}

export function totalStandardCost(amountSent: number, midMarket: number, quote: Quote) {
  return quote.fee.total + standardExchangeRateFee(amountSent, midMarket, quote)
}
